import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@lifepay/rc-ui-toolkit";

import { TRANSACTION_SMS_STATUSES } from "../CONSTANTS";

function SMSStatusBadge(props) {
  const { status } = props;

  switch (status) {
    case TRANSACTION_SMS_STATUSES.NOT_PROCESSED: {
      return <Badge type={"gray"}>{"SMS ‎ожидает отправки"}</Badge>;
    }
    case TRANSACTION_SMS_STATUSES.SENT: {
      return <Badge type={"green"}>{"SMS ‎‎✔"}</Badge>;
    }
    case TRANSACTION_SMS_STATUSES.SWITCHED_OFF: {
      return <Badge type={"green"}>{"без SMS"}</Badge>;
    }
    case TRANSACTION_SMS_STATUSES.ERROR_PROC: {
      return <Badge type={"red"}>{"SMS ‎‎✖"}</Badge>;
    }
    case TRANSACTION_SMS_STATUSES.ERROR_PROVIDER: {
      return <Badge type={"red"}>{"SMS ‎‎✖"}</Badge>;
    }
    default: {
      return <Badge type={"red"}>{`SMS ‎‎✖ ${status}`}</Badge>;
    }
  }
}

SMSStatusBadge.displayName = "SMSStatusBadge";

SMSStatusBadge.propTypes = {
  status: PropTypes.number,
};

SMSStatusBadge.defaultProps = {};

export default SMSStatusBadge;



// WEBPACK FOOTER //
// ./src/components/processing/transaction/SMSStatusBadge.js